import React from 'react';
import { GenericErrorPage } from 'components/error-pages/generic';
import { getUrlSearchParams } from '../../utils/getUrlSearchParams';
import { GenericErrorType } from '../../components/error-pages/generic/utils/enums';

export const ErrorPage: React.FC = () => {
    const errorType = getUrlSearchParams().get('errorType') ?? GenericErrorType.GENERAL_ERR;
    return <GenericErrorPage errorType={errorType as GenericErrorType} />;
};
